import { useFlagsmithLoading } from '@flagsmith/flagsmith/react';
import Checkout from '../Checkout/Checkout';

export const CheckoutWithFeatureFlag = () => {
  const flagsmithLoading = useFlagsmithLoading();
  const isFlagLoading = flagsmithLoading === undefined || flagsmithLoading?.isLoading;

  if (isFlagLoading) {
    return null;
  }

  return <Checkout />;
};
